import { render, staticRenderFns } from "./EditTaxComponent.vue?vue&type=template&id=6e975408&"
import script from "./EditTaxComponent.vue?vue&type=script&lang=js&"
export * from "./EditTaxComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports